<script lang="ts">
	export let title: string
	export let text: string
	export let link: string
</script>

<a
	href={link}
	class="tracking rounded-2xl bg-white p-8 shadow-md transition-shadow hover:shadow-lg"
>
	<h4 class="unstyled text-lg font-semibold leading-6 tracking-wide text-primary-500 underline">
		{title}
	</h4>
	<p class="mt-4 text-sm leading-6">{text}</p>
</a>
